import {ReportRow} from './ReportTypes';

/**
 * The Private tab is the viewer's own private reports. A private report shared with them is not
 * theirs to manage, so it belongs with the reports they were given access to instead.
 */
export const selectPrivateReports = (reports: ReportRow[]): ReportRow[] =>
	reports.filter(report => report.isReportOwner && report.privateAccess);

/**
 * The Shared tab is everything the viewer reaches that is not their own private report: the reports
 * open to the whole company, plus the private ones shared with them.
 *
 * Sharing is the test, not privacy. An admin's list is the whole company, so their view would
 * otherwise fill with other people's private reports; those carry no share and stay in the All tab.
 *
 * A private report the viewer owns is the Private tab's, share or no share. A share row outlives an
 * ownership transfer, so an owner can hold one on their own report, and the two tabs must never
 * count the same row twice.
 */
export const selectSharedReports = (reports: ReportRow[]): ReportRow[] =>
	reports.filter(report => !report.privateAccess || (report.isSharedWithViewer && !report.isReportOwner));
